import React from "react";
import { Controller } from "react-hook-form";
import { Col, Row } from "reactstrap";
import { URL_REGEX } from "../utils/constant";
import InputField from "./layout/InputField";

const EmailSignatureInput = ({
  control,
  errors,
  setDetail,
  signatureDetail,
}) => {
  return (
    <Row>
      <Col lg="4" md="6" sm="12" xs="12">
        <Controller
          control={control}
          name="companyUrl"
          rules={{
            required: { value: true, message: "CompanyUrl is required!" },
            pattern: { value: URL_REGEX, message: "Company URL is not valid!" },
          }}
          render={({ field }) => (
            <InputField
              label="Company Url"
              isRequired={true}
              inputtype="text"
              placeholder="Company Url"
              inputid="companyUrl"
              value={field.value ?? ''}
              onChange={(e) => {
                field.onChange(e.target.value);
                setDetail((s) => ({ ...s, companyUrl: e.target.value }));
              }}
              onBlur={field.onBlur}
              inputRef={field.ref}
              errMsg={errors?.companyUrl?.message as any}
            />
          )}
        />
      </Col>
      <Col lg="4" md="6" sm="12" xs="12">
        <Controller
          control={control}
          name="fbUrl"
          rules={{
            pattern: { value: URL_REGEX, message: "Facebook URL is not valid!" },
          }}
          render={({ field }) => (
            <InputField
              inputtype="text"
              label="Facebook"
              inputid="fbUrl"
              placeholder="Facebook URL"
              value={field.value ?? ''}
              onChange={(e) => {
                field.onChange(e.target.value);
                setDetail((s) => ({ ...s, fbUrl: e.target.value }));
              }}
              onBlur={field.onBlur}
              inputRef={field.ref}
              errMsg={errors?.fbUrl?.message as any}
            />
          )}
        />
      </Col>
      <Col lg="4" md="6" sm="12" xs="12">
        <Controller
          control={control}
          name="instaUrl"
          render={({ field }) => (
            <InputField
              inputtype="text"
              label="Instagram"
              inputid="instaUrl"
              placeholder="@instagram"
              value={field.value ?? ''}
              onChange={(e) => {
                field.onChange(e.target.value);
                setDetail((s) => ({ ...s, instaUrl: e.target.value }));
              }}
              onBlur={field.onBlur}
              inputRef={field.ref}
              errMsg={errors?.instaUrl?.message as any}
            />
          )}
        />
      </Col>
      <Col lg="4" md="6" sm="12" xs="12">
        <Controller
          control={control}
          name="twitterUrl"
          render={({ field }) => (
            <InputField
              inputtype="text"
              label="Twitter"
              inputid="twitterUrl"
              placeholder="@twitter"
              value={field.value ?? ''}
              onChange={(e) => {
                field.onChange(e.target.value);
                setDetail((s) => ({ ...s, twitterUrl: e.target.value }));
              }}
              onBlur={field.onBlur}
              inputRef={field.ref}
              errMsg={errors?.twitterUrl?.message as any}
            />
          )}
        />
      </Col>
      <Col lg="4" md="6" sm="12" xs="12">
        <Controller
          control={control}
          name="youtubeUrl"
          rules={{
            pattern: { value: URL_REGEX, message: "YouTube URL is not valid!" },
          }}
          render={({ field }) => (
            <InputField
              inputtype="text"
              label="YouTube"
              inputid="youtubeUrl"
              placeholder="YouTube Url"
              value={field.value ?? ''}
              onChange={(e) => {
                field.onChange(e.target.value);
                setDetail((s) => ({ ...s, youtubeUrl: e.target.value }));
              }}
              onBlur={field.onBlur}
              inputRef={field.ref}
              errMsg={errors?.youtubeUrl?.message as any}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default EmailSignatureInput;
